import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssabilPackingRoutingModule } from './assabil-packing-routing.module';
import { AssabilPackingMenuComponent } from './assabil-packing-menu/assabil-packing-menu.component';
import { ToolsModule } from '../tools/tools.module';
import { AssabilAdminModule } from '../assabil-admin/assabil-admin.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PackingOrderPipe } from './pipes/packing-order-pipe';
import { PackingOrderListComponent } from './components/packing-order-list/packing-order-list.component';
import { PackingOrderWidgetComponent } from './components/packing-order-widget/packing-order-widget.component';
import { NgxGaugeModule } from 'ngx-gauge';
import { PackingOrderListMobileComponent } from './components-mobile/packing-order-list-mobile/packing-order-list-mobile.component';
import { PackingOrderStepsComponent } from './components/packing-order-steps/packing-order-steps.component';
import { PackPackingOrderStepListMobileComponent } from './components-mobile/pack-packing-order-step-list-mobile/pack-packing-order-step-list-mobile.component';
import { PackingPorderListMobileComponent } from './components-mobile/packing-porder-list-mobile/packing-porder-list-mobile.component';


@NgModule({
  declarations: [
    AssabilPackingMenuComponent,
    PackingOrderListComponent,
    PackingOrderWidgetComponent,
    PackingOrderListMobileComponent,
    PackPackingOrderStepListMobileComponent,
    PackingPorderListMobileComponent,
    PackingOrderPipe,
    PackingOrderStepsComponent
  ],
  imports: [
    CommonModule,
    ToolsModule,
    NgxGaugeModule,
    AssabilAdminModule,
    AssabilPackingRoutingModule,
    NgxDatatableModule,
    BsDatepickerModule.forRoot(),
  ],
  exports: [
    AssabilPackingMenuComponent
  ]
})
export class AssabilPackingModule { }
